export const languageList = {
  aa: {
    name: 'Afar',
    code: 'aa',
    flag: '',
  },
  ab: {
    name: 'Abkhazian',
    code: 'ab',
    flag: '',
  },
  ae: {
    name: 'Avestan',
    code: 'ae',
    flag: '',
  },
  af: {
    name: 'Afrikaans',
    code: 'af',
    flag: '',
  },
  ak: {
    name: 'Akan',
    code: 'ak',
    flag: '',
  },
  am: {
    name: 'Amharic',
    code: 'am',
    flag: '',
  },
  an: {
    name: 'Aragonese',
    code: 'an',
    flag: '',
  },
  'ar-ae': {
    name: 'Arabic (U.A.E.)',
    code: 'ar-ae',
    flag: '🇦🇪',
  },
  'ar-bh': {
    name: 'Arabic (Bahrain)',
    code: 'ar-bh',
    flag: '🇧🇭',
  },
  'ar-dz': {
    name: 'Arabic (Algeria)',
    code: 'ar-dz',
    flag: '🇩🇿',
  },
  'ar-eg': {
    name: 'Arabic (Egypt)',
    code: 'ar-eg',
    flag: '🇪🇬',
  },
  'ar-iq': {
    name: 'Arabic (Iraq)',
    code: 'ar-iq',
    flag: '🇮🇶',
  },
  'ar-jo': {
    name: 'Arabic (Jordan)',
    code: 'ar-jo',
    flag: '🇯🇴',
  },
  'ar-kw': {
    name: 'Arabic (Kuwait)',
    code: 'ar-kw',
    flag: '🇰🇼',
  },
  'ar-lb': {
    name: 'Arabic (Lebanon)',
    code: 'ar-lb',
    flag: '🇱🇧',
  },
  'ar-ly': {
    name: 'Arabic (Libya)',
    code: 'ar-ly',
    flag: '🇱🇾',
  },
  'ar-ma': {
    name: 'Arabic (Morocco)',
    code: 'ar-ma',
    flag: '🇲🇦',
  },
  'ar-om': {
    name: 'Arabic (Oman)',
    code: 'ar-om',
    flag: '🇴🇲',
  },
  'ar-qa': {
    name: 'Arabic (Qatar)',
    code: 'ar-qa',
    flag: '🇶🇦',
  },
  'ar-sa': {
    name: 'Arabic (Saudi Arabia)',
    code: 'ar-sa',
    flag: '🇸🇦',
  },
  'ar-sy': {
    name: 'Arabic (Syria)',
    code: 'ar-sy',
    flag: '🇸🇾',
  },
  'ar-tn': {
    name: 'Arabic (Tunisia)',
    code: 'ar-tn',
    flag: '🇹🇳',
  },
  'ar-ye': {
    name: 'Arabic (Yemen)',
    code: 'ar-ye',
    flag: '🇾🇪',
  },
  ar: {
    name: 'Arabic',
    code: 'ar',
    flag: '',
  },
  as: {
    name: 'Assamese',
    code: 'as',
    flag: '',
  },
  av: {
    name: 'Avaric',
    code: 'av',
    flag: '',
  },
  ay: {
    name: 'Aymara',
    code: 'ay',
    flag: '',
  },
  az: {
    name: 'Azeri',
    code: 'az',
    flag: '',
  },
  ba: {
    name: 'Bashkir',
    code: 'ba',
    flag: '',
  },
  be: {
    name: 'Belarusian',
    code: 'be',
    flag: '',
  },
  bg: {
    name: 'Bulgarian',
    code: 'bg',
    flag: '',
  },
  bh: {
    name: 'Bihari',
    code: 'bh',
    flag: '',
  },
  bi: {
    name: 'Bislama',
    code: 'bi',
    flag: '',
  },
  bm: {
    name: 'Bambara',
    code: 'bm',
    flag: '',
  },
  bn: {
    name: 'Bengali',
    code: 'bn',
    flag: '',
  },
  bo: {
    name: 'Tibetan',
    code: 'bo',
    flag: '',
  },
  br: {
    name: 'Breton',
    code: 'br',
    flag: '',
  },
  bs: {
    name: 'Bosnian',
    code: 'bs',
    flag: '',
  },
  ca: {
    name: 'Catalan',
    code: 'ca',
    flag: '',
  },
  ce: {
    name: 'Chechen',
    code: 'ce',
    flag: '',
  },
  ch: {
    name: 'Chamorro',
    code: 'ch',
    flag: '',
  },
  co: {
    name: 'Corsican',
    code: 'co',
    flag: '',
  },
  cr: {
    name: 'Cree',
    code: 'cr',
    flag: '',
  },
  cs: {
    name: 'Czech',
    code: 'cs',
    flag: '',
  },
  cu: {
    name: 'Church Slavonic',
    code: 'cu',
    flag: '',
  },
  cv: {
    name: 'Chuvash',
    code: 'cv',
    flag: '',
  },
  cy: {
    name: 'Welsh',
    code: 'cy',
    flag: '',
  },
  da: {
    name: 'Danish',
    code: 'da',
    flag: '',
  },
  'de-at': {
    name: 'German (Austria)',
    code: 'de-at',
    flag: '🇦🇹',
  },
  'de-ch': {
    name: 'German (Switzerland)',
    code: 'de-ch',
    flag: '🇨🇭',
  },
  'de-de': {
    name: 'German (Germany)',
    code: 'de-de',
    flag: '🇩🇪',
  },
  'de-li': {
    name: 'German (Liechtenstein)',
    code: 'de-li',
    flag: '🇱🇮',
  },
  'de-lu': {
    name: 'German (Luxembourg)',
    code: 'de-lu',
    flag: '🇱🇺',
  },
  de: {
    name: 'German',
    code: 'de',
    flag: '🇩🇪',
  },
  div: {
    name: 'Divehi',
    code: 'div',
    flag: '',
  },
  dv: {
    name: 'Divehi',
    code: 'dv',
    flag: '',
  },
  dz: {
    name: 'Bhutani',
    code: 'dz',
    flag: '',
  },
  ee: {
    name: 'Ewe',
    code: 'ee',
    flag: '',
  },
  el: {
    name: 'Greek',
    code: 'el',
    flag: '🇬🇷',
  },
  'en-au': {
    name: 'English (Australia)',
    code: 'en-au',
    flag: '🇦🇺',
  },
  'en-bz': {
    name: 'English (Belize)',
    code: 'en-bz',
    flag: '🇧🇿',
  },
  'en-ca': {
    name: 'English (Canada)',
    code: 'en-ca',
    flag: '🇨🇦',
  },
  'en-cb': {
    name: 'English (Caribbean)',
    code: 'en-cb',
    flag: '',
  },
  'en-gb': {
    name: 'English (United Kingdom)',
    code: 'en-gb',
    flag: '🇬🇧',
  },
  'en-ie': {
    name: 'English (Ireland)',
    code: 'en-ie',
    flag: '🇮🇪',
  },
  'en-jm': {
    name: 'English (Jamaica)',
    code: 'en-jm',
    flag: '🇯🇲',
  },
  'en-nz': {
    name: 'English (New Zealand)',
    code: 'en-nz',
    flag: '🇳🇿',
  },
  'en-ph': {
    name: 'English (Philippines)',
    code: 'en-ph',
    flag: '🇵🇭',
  },
  'en-tt': {
    name: 'English (Trinidad and Tobago)',
    code: 'en-tt',
    flag: '🇹🇹',
  },
  'en-us': {
    name: 'English (United States)',
    code: 'en-us',
    flag: '🇺🇸',
  },
  'en-za': {
    name: 'English (South Africa)',
    code: 'en-za',
    flag: '🇿🇦',
  },
  'en-zw': {
    name: 'English (Zimbabwe)',
    code: 'en-zw',
    flag: '🇿🇼',
  },
  en: {
    name: 'English',
    code: 'en',
    flag: '🇬🇧',
  },
  eo: {
    name: 'Esperanto',
    code: 'eo',
    flag: '',
  },
  'es-ar': {
    name: 'Spanish (Argentina)',
    code: 'es-ar',
    flag: '🇦🇷',
  },
  'es-bo': {
    name: 'Spanish (Bolivia)',
    code: 'es-bo',
    flag: '🇧🇴',
  },
  'es-cl': {
    name: 'Spanish (Chile)',
    code: 'es-cl',
    flag: '🇨🇱',
  },
  'es-co': {
    name: 'Spanish (Colombia)',
    code: 'es-co',
    flag: '🇨🇴',
  },
  'es-cr': {
    name: 'Spanish (Costa Rica)',
    code: 'es-cr',
    flag: '🇨🇷',
  },
  'es-do': {
    name: 'Spanish (Dominican Republic)',
    code: 'es-do',
    flag: '🇩🇴',
  },
  'es-ec': {
    name: 'Spanish (Ecuador)',
    code: 'es-ec',
    flag: '🇪🇨',
  },
  'es-es': {
    name: 'Spanish (Spain)',
    code: 'es-es',
    flag: '🇪🇸',
  },
  'es-gt': {
    name: 'Spanish (Guatemala)',
    code: 'es-gt',
    flag: '🇬🇹',
  },
  'es-hn': {
    name: 'Spanish (Honduras)',
    code: 'es-hn',
    flag: '🇭🇳',
  },
  'es-mx': {
    name: 'Spanish (Mexico)',
    code: 'es-mx',
    flag: '🇲🇽',
  },
  'es-ni': {
    name: 'Spanish (Nicaragua)',
    code: 'es-ni',
    flag: '🇳🇮',
  },
  'es-pa': {
    name: 'Spanish (Panama)',
    code: 'es-pa',
    flag: '🇵🇦',
  },
  'es-pe': {
    name: 'Spanish (Peru)',
    code: 'es-pe',
    flag: '🇵🇪',
  },
  'es-pr': {
    name: 'Spanish (Puerto Rico)',
    code: 'es-pr',
    flag: '🇵🇷',
  },
  'es-py': {
    name: 'Spanish (Paraguay)',
    code: 'es-py',
    flag: '🇵🇾',
  },
  'es-sv': {
    name: 'Spanish (El Salvador)',
    code: 'es-sv',
    flag: '🇸🇻',
  },
  'es-us': {
    name: 'Spanish (United States)',
    code: 'es-us',
    flag: '🇺🇸',
  },
  'es-uy': {
    name: 'Spanish (Uruguay)',
    code: 'es-uy',
    flag: '🇺🇾',
  },
  'es-ve': {
    name: 'Spanish (Venezuela)',
    code: 'es-ve',
    flag: '🇻🇪',
  },
  es: {
    name: 'Spanish',
    code: 'es',
    flag: '',
  },
  et: {
    name: 'Estonian',
    code: 'et',
    flag: '',
  },
  eu: {
    name: 'Basque',
    code: 'eu',
    flag: '',
  },
  fa: {
    name: 'Farsi',
    code: 'fa',
    flag: '',
  },
  ff: {
    name: 'Fulah',
    code: 'ff',
    flag: '',
  },
  fi: {
    name: 'Finnish',
    code: 'fi',
    flag: '',
  },
  fj: {
    name: 'Fiji',
    code: 'fj',
    flag: '',
  },
  fo: {
    name: 'Faroese',
    code: 'fo',
    flag: '',
  },
  'fr-be': {
    name: 'French (Belgium)',
    code: 'fr-be',
    flag: '🇫🇷',
  },
  'fr-ca': {
    name: 'French (Canada)',
    code: 'fr-ca',
    flag: '🇫🇷',
  },
  'fr-ch': {
    name: 'French (Switzerland)',
    code: 'fr-ch',
    flag: '🇫🇷',
  },
  'fr-fr': {
    name: 'French (France)',
    code: 'fr-fr',
    flag: '🇫🇷',
  },
  'fr-lu': {
    name: 'French (Luxembourg)',
    code: 'fr-lu',
    flag: '🇱🇺',
  },
  'fr-mc': {
    name: 'French (Monaco)',
    code: 'fr-mc',
    flag: '🇲🇨',
  },
  fr: {
    name: 'French',
    code: 'fr',
    flag: '🇫🇷',
  },
  fy: {
    name: 'Frisian',
    code: 'fy',
    flag: '',
  },
  ga: {
    name: 'Irish',
    code: 'ga',
    flag: '',
  },
  gd: {
    name: 'Gaelic',
    code: 'gd',
    flag: '',
  },
  gl: {
    name: 'Galician',
    code: 'gl',
    flag: '',
  },
  gn: {
    name: 'Guarani',
    code: 'gn',
    flag: '',
  },
  gu: {
    name: 'Gujarati',
    code: 'gu',
    flag: '',
  },
  gv: {
    name: 'Manx',
    code: 'gv',
    flag: '',
  },
  ha: {
    name: 'Hausa',
    code: 'ha',
    flag: '',
  },
  he: {
    name: 'Hebrew',
    code: 'he',
    flag: '',
  },
  hi: {
    name: 'Hindi',
    code: 'hi',
    flag: '',
  },
  ho: {
    name: 'Hiri Motu',
    code: 'ho',
    flag: '',
  },
  'hr-ba': {
    name: 'Croatian (Bosnia and Herzegovina)',
    code: 'hr-ba',
    flag: '🇧🇦',
  },
  'hr-hr': {
    name: 'Croatian (Croatia)',
    code: 'hr-hr',
    flag: '🇭🇷',
  },
  hr: {
    name: 'Croatian',
    code: 'hr',
    flag: '',
  },
  ht: {
    name: 'Haitian',
    code: 'ht',
    flag: '',
  },
  hu: {
    name: 'Hungarian',
    code: 'hu',
    flag: '',
  },
  hy: {
    name: 'Armenian',
    code: 'hy',
    flag: '',
  },
  hz: {
    name: 'Herero',
    code: 'hz',
    flag: '',
  },
  ia: {
    name: 'Interlingua',
    code: 'ia',
    flag: '',
  },
  id: {
    name: 'Indonesian',
    code: 'id',
    flag: '',
  },
  ie: {
    name: 'Interlingue',
    code: 'ie',
    flag: '',
  },
  ig: {
    name: 'Igbo',
    code: 'ig',
    flag: '',
  },
  ii: {
    name: 'Sichuan Yi',
    code: 'ii',
    flag: '',
  },
  ik: {
    name: 'Inupiak',
    code: 'ik',
    flag: '',
  },
  in: {
    name: 'Indonesian',
    code: 'in',
    flag: '',
  },
  io: {
    name: 'Ido',
    code: 'io',
    flag: '',
  },
  is: {
    name: 'Icelandic',
    code: 'is',
    flag: '',
  },
  'it-ch': {
    name: 'Italian (Switzerland)',
    code: 'it-ch',
    flag: '🇮🇹',
  },
  'it-it': {
    name: 'Italian (Italy)',
    code: 'it-it',
    flag: '🇮🇹',
  },
  it: {
    name: 'Italian',
    code: 'it',
    flag: '🇮🇹',
  },
  iu: {
    name: 'Inuktitut',
    code: 'iu',
    flag: '',
  },
  iw: {
    name: 'Hebrew',
    code: 'iw',
    flag: '',
  },
  ja: {
    name: 'Japanese',
    code: 'ja',
    flag: '',
  },
  ji: {
    name: 'Yiddish',
    code: 'ji',
    flag: '',
  },
  jv: {
    name: 'Javanese',
    code: 'jv',
    flag: '',
  },
  jw: {
    name: 'Javanese',
    code: 'jw',
    flag: '',
  },
  ka: {
    name: 'Georgian',
    code: 'ka',
    flag: '',
  },
  kg: {
    name: 'Kongo',
    code: 'kg',
    flag: '',
  },
  ki: {
    name: 'Kikuyu',
    code: 'ki',
    flag: '',
  },
  kj: {
    name: 'Kuanyama',
    code: 'kj',
    flag: '',
  },
  kk: {
    name: 'Kazakh',
    code: 'kk',
    flag: '',
  },
  kl: {
    name: 'Greenlandic',
    code: 'kl',
    flag: '',
  },
  km: {
    name: 'Cambodian',
    code: 'km',
    flag: '',
  },
  kn: {
    name: 'Kannada',
    code: 'kn',
    flag: '',
  },
  ko: {
    name: 'Korean',
    code: 'ko',
    flag: '',
  },
  kok: {
    name: 'Konkani',
    code: 'kok',
    flag: '',
  },
  kr: {
    name: 'Kanuri',
    code: 'kr',
    flag: '',
  },
  ks: {
    name: 'Kashmiri',
    code: 'ks',
    flag: '',
  },
  ku: {
    name: 'Kurdish',
    code: 'ku',
    flag: '',
  },
  kv: {
    name: 'Komi',
    code: 'kv',
    flag: '',
  },
  kw: {
    name: 'Cornish',
    code: 'kw',
    flag: '',
  },
  ky: {
    name: 'Kirghiz',
    code: 'ky',
    flag: '',
  },
  kz: {
    name: 'Kyrgyz',
    code: 'kz',
    flag: '',
  },
  la: {
    name: 'Latin',
    code: 'la',
    flag: '',
  },
  lb: {
    name: 'Luxembourgish',
    code: 'lb',
    flag: '',
  },
  lg: {
    name: 'Ganda',
    code: 'lg',
    flag: '',
  },
  li: {
    name: 'Limburgan',
    code: 'li',
    flag: '',
  },
  ln: {
    name: 'Lingala',
    code: 'ln',
    flag: '',
  },
  lo: {
    name: 'Laothian',
    code: 'lo',
    flag: '',
  },
  ls: {
    name: 'Slovenian',
    code: 'ls',
    flag: '',
  },
  lt: {
    name: 'Lithuanian',
    code: 'lt',
    flag: '',
  },
  lu: {
    name: 'Luba-Katanga',
    code: 'lu',
    flag: '',
  },
  lv: {
    name: 'Latvian',
    code: 'lv',
    flag: '',
  },
  mg: {
    name: 'Malagasy',
    code: 'mg',
    flag: '',
  },
  mh: {
    name: 'Marshallese',
    code: 'mh',
    flag: '',
  },
  mi: {
    name: 'Maori',
    code: 'mi',
    flag: '',
  },
  mk: {
    name: 'FYRO Macedonian',
    code: 'mk',
    flag: '',
  },
  ml: {
    name: 'Malayalam',
    code: 'ml',
    flag: '',
  },
  mn: {
    name: 'Mongolian',
    code: 'mn',
    flag: '',
  },
  mo: {
    name: 'Moldavian',
    code: 'mo',
    flag: '',
  },
  mr: {
    name: 'Marathi',
    code: 'mr',
    flag: '',
  },
  'ms-bn': {
    name: 'Malay (Brunei Darussalam)',
    code: 'ms-bn',
    flag: '🇧🇳',
  },
  'ms-my': {
    name: 'Malay (Malaysia)',
    code: 'ms-my',
    flag: '🇲🇾',
  },
  ms: {
    name: 'Malay',
    code: 'ms',
    flag: '',
  },
  mt: {
    name: 'Maltese',
    code: 'mt',
    flag: '',
  },
  my: {
    name: 'Burmese',
    code: 'my',
    flag: '',
  },
  na: {
    name: 'Nauru',
    code: 'na',
    flag: '',
  },
  nb: {
    name: 'Norwegian (Bokmal)',
    code: 'nb',
    flag: '',
  },
  nd: {
    name: 'North Ndebele',
    code: 'nd',
    flag: '',
  },
  ne: {
    name: 'Nepali (India)',
    code: 'ne',
    flag: '',
  },
  ng: {
    name: 'Ndonga',
    code: 'ng',
    flag: '',
  },
  'nl-be': {
    name: 'Dutch (Belgium)',
    code: 'nl-be',
    flag: '🇧🇪',
  },
  'nl-nl': {
    name: 'Dutch (Netherlands)',
    code: 'nl-nl',
    flag: '🇳🇱',
  },
  nl: {
    name: 'Dutch',
    code: 'nl',
    flag: '',
  },
  nn: {
    name: 'Norwegian (Nynorsk)',
    code: 'nn',
    flag: '',
  },
  no: {
    name: 'Norwegian',
    code: 'no',
    flag: '',
  },
  nr: {
    name: 'South Ndebele',
    code: 'nr',
    flag: '',
  },
  ns: {
    name: 'Northern Sotho',
    code: 'ns',
    flag: '',
  },
  nv: {
    name: 'Navajo',
    code: 'nv',
    flag: '',
  },
  ny: {
    name: 'Chichewa',
    code: 'ny',
    flag: '',
  },
  oc: {
    name: 'Occitan',
    code: 'oc',
    flag: '',
  },
  oj: {
    name: 'Ojibwa',
    code: 'oj',
    flag: '',
  },
  om: {
    name: '(Afan)/Oromoor/Oriya',
    code: 'om',
    flag: '',
  },
  or: {
    name: 'Oriya',
    code: 'or',
    flag: '',
  },
  os: {
    name: 'Ossetian',
    code: 'os',
    flag: '',
  },
  pa: {
    name: 'Punjabi',
    code: 'pa',
    flag: '',
  },
  pi: {
    name: 'Pali',
    code: 'pi',
    flag: '',
  },
  pl: {
    name: 'Polish',
    code: 'pl',
    flag: '🇵🇱',
  },
  ps: {
    name: 'Pashto/Pushto',
    code: 'ps',
    flag: '',
  },
  'pt-br': {
    name: 'Portuguese (Brazil)',
    code: 'pt-br',
    flag: '🇧🇷',
  },
  'pt-pt': {
    name: 'Portuguese (Portugal)',
    code: 'pt-pt',
    flag: '🇵🇹',
  },
  pt: {
    name: 'Portuguese',
    code: 'pt',
    flag: '',
  },
  'qu-bo': {
    name: 'Quechua (Bolivia)',
    code: 'qu-bo',
    flag: '🇧🇴',
  },
  'qu-ec': {
    name: 'Quechua (Ecuador)',
    code: 'qu-ec',
    flag: '🇪🇨',
  },
  'qu-pe': {
    name: 'Quechua (Peru)',
    code: 'qu-pe',
    flag: '🇵🇪',
  },
  qu: {
    name: 'Quechua',
    code: 'qu',
    flag: '',
  },
  rm: {
    name: 'Rhaeto-Romanic',
    code: 'rm',
    flag: '',
  },
  rn: {
    name: 'Kirundi',
    code: 'rn',
    flag: '',
  },
  ro: {
    name: 'Romanian',
    code: 'ro',
    flag: '',
  },
  ru: {
    name: 'Russian',
    code: 'ru',
    flag: '',
  },
  rw: {
    name: 'Kinyarwanda',
    code: 'rw',
    flag: '',
  },
  sa: {
    name: 'Sanskrit',
    code: 'sa',
    flag: '',
  },
  sb: {
    name: 'Sorbian',
    code: 'sb',
    flag: '',
  },
  sc: {
    name: 'Sardinian',
    code: 'sc',
    flag: '',
  },
  sd: {
    name: 'Sindhi',
    code: 'sd',
    flag: '',
  },
  'se-fi': {
    name: 'Sami (Finland)',
    code: 'se-fi',
    flag: '🇫🇮',
  },
  'se-no': {
    name: 'Sami (Norway)',
    code: 'se-no',
    flag: '🇳🇴',
  },
  'se-se': {
    name: 'Sami (Sweden)',
    code: 'se-se',
    flag: '🇸🇪',
  },
  se: {
    name: 'Sami',
    code: 'se',
    flag: '',
  },
  sg: {
    name: 'Sangro',
    code: 'sg',
    flag: '',
  },
  sh: {
    name: 'Serbo-Croatian',
    code: 'sh',
    flag: '',
  },
  si: {
    name: 'Singhalese',
    code: 'si',
    flag: '',
  },
  sk: {
    name: 'Slovak',
    code: 'sk',
    flag: '',
  },
  sl: {
    name: 'Slovenian',
    code: 'sl',
    flag: '',
  },
  sm: {
    name: 'Samoan',
    code: 'sm',
    flag: '',
  },
  sn: {
    name: 'Shona',
    code: 'sn',
    flag: '',
  },
  so: {
    name: 'Somali',
    code: 'so',
    flag: '',
  },
  sq: {
    name: 'Albanian',
    code: 'sq',
    flag: '',
  },
  'sr-ba': {
    name: 'Serbian (Bosnia and Herzegovina)',
    code: 'sr-ba',
    flag: '🇧🇦',
  },
  'sr-sp': {
    name: 'Serbian (Serbia and Montenegro)',
    code: 'sr-sp',
    flag: '',
  },
  sr: {
    name: 'Serbian',
    code: 'sr',
    flag: '',
  },
  ss: {
    name: 'Siswati',
    code: 'ss',
    flag: '',
  },
  st: {
    name: 'Sesotho',
    code: 'st',
    flag: '',
  },
  su: {
    name: 'Sundanese',
    code: 'su',
    flag: '',
  },
  'sv-fi': {
    name: 'Swedish (Finland)',
    code: 'sv-fi',
    flag: '🇫🇮',
  },
  'sv-se': {
    name: 'Swedish (Sweden)',
    code: 'sv-se',
    flag: '🇸🇪',
  },
  sv: {
    name: 'Swedish',
    code: 'sv',
    flag: '',
  },
  sw: {
    name: 'Swahili',
    code: 'sw',
    flag: '',
  },
  sx: {
    name: 'Sutu',
    code: 'sx',
    flag: '',
  },
  syr: {
    name: 'Syriac',
    code: 'syr',
    flag: '',
  },
  ta: {
    name: 'Tamil',
    code: 'ta',
    flag: '',
  },
  te: {
    name: 'Telugu',
    code: 'te',
    flag: '',
  },
  tg: {
    name: 'Tajik',
    code: 'tg',
    flag: '',
  },
  th: {
    name: 'Thai',
    code: 'th',
    flag: '',
  },
  ti: {
    name: 'Tigrinya',
    code: 'ti',
    flag: '',
  },
  tk: {
    name: 'Turkmen',
    code: 'tk',
    flag: '',
  },
  tl: {
    name: 'Tagalog',
    code: 'tl',
    flag: '',
  },
  tn: {
    name: 'Tswana',
    code: 'tn',
    flag: '',
  },
  to: {
    name: 'Tonga',
    code: 'to',
    flag: '',
  },
  tr: {
    name: 'Turkish',
    code: 'tr',
    flag: '',
  },
  ts: {
    name: 'Tsonga',
    code: 'ts',
    flag: '',
  },
  tt: {
    name: 'Tatar',
    code: 'tt',
    flag: '',
  },
  tw: {
    name: 'Twi',
    code: 'tw',
    flag: '',
  },
  ty: {
    name: 'Tahitian',
    code: 'ty',
    flag: '',
  },
  ug: {
    name: 'Uighur',
    code: 'ug',
    flag: '',
  },
  uk: {
    name: 'Ukrainian',
    code: 'uk',
    flag: '',
  },
  ur: {
    name: 'Urdu',
    code: 'ur',
    flag: '',
  },
  us: {
    name: 'English',
    code: 'us',
    flag: '',
  },
  uz: {
    name: 'Uzbek',
    code: 'uz',
    flag: '',
  },
  ve: {
    name: 'Venda',
    code: 've',
    flag: '',
  },
  vi: {
    name: 'Vietnamese',
    code: 'vi',
    flag: '',
  },
  vo: {
    name: 'Volapuk',
    code: 'vo',
    flag: '',
  },
  wa: {
    name: 'Walloon',
    code: 'wa',
    flag: '',
  },
  wo: {
    name: 'Wolof',
    code: 'wo',
    flag: '',
  },
  xh: {
    name: 'Xhosa',
    code: 'xh',
    flag: '',
  },
  yi: {
    name: 'Yiddish',
    code: 'yi',
    flag: '',
  },
  yo: {
    name: 'Yoruba',
    code: 'yo',
    flag: '',
  },
  za: {
    name: 'Zhuang',
    code: 'za',
    flag: '',
  },
  'zh-cn': {
    name: 'Chinese (China)',
    code: 'zh-cn',
    flag: '🇨🇳',
  },
  'zh-hk': {
    name: 'Chinese (Hong Kong SAR)',
    code: 'zh-hk',
    flag: '🇭🇰',
  },
  'zh-mo': {
    name: 'Chinese (Macau SAR)',
    code: 'zh-mo',
    flag: '🇲🇴',
  },
  'zh-sg': {
    name: 'Chinese (Singapore)',
    code: 'zh-sg',
    flag: '🇸🇬',
  },
  'zh-tw': {
    name: 'Chinese (Taiwan)',
    code: 'zh-tw',
    flag: '🇹🇼',
  },
  zh: {
    name: 'Chinese',
    code: 'zh',
    flag: '',
  },
  zu: {
    name: 'Zulu',
    code: 'zu',
    flag: '',
  },
}
